export default __webpack_public_path__ + "static/media/files-glery4.27280059.jpg";